import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/app';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root; templates/admin_spa.html did not render.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
